<mt-select
    :model-value="value"
    :options="options"
    @update:model-value="onChange"
    :label="$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-model.selectLabel')"
></mt-select>
